import React from 'react';
import './_ErrorIcon.scss';

const ErrorIcon: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className="icon-wrong" viewBox="0 0 62 62">
      <path d="M31.622.71c-16.85 0-30.5 13.65-30.5 30.501 0 16.85 13.66 30.5 30.5 30.5s30.5-13.65 30.5-30.5-13.66-30.5-30.5-30.5zm15.18 42.151l-3.54 3.54-11.64-11.66-11.65 11.66-3.54-3.54 11.65-11.65-11.65-11.65 3.54-3.54 11.66 11.65 11.65-11.65 3.54 3.54-11.67 11.65z"></path>
    </svg>
  );
};

export default ErrorIcon;
